import React, { Component } from "react";
import UsersTable from "../../components/usermanagement/UsersTable";
import Search from "../../components/Search";
import axios from "../../util/axios";
import { trackPromise } from "react-promise-tracker";
import { Link } from "react-router-dom";
import CobrandSelector from "../../components/cobrandselection/CobrandSelector";

class Users extends Component {
  getCobrandById(cobrandId) {
    var cobrands = JSON.parse(localStorage.getItem("userData")).cobrands;
    var index = cobrands.findIndex(function(cobrand, i) {
      return cobrand.id.toString() === cobrandId;
    });
    return index > -1 ? cobrands[index] : cobrands[0];
  }

  state = {
    users: [],
    searchTerm: "",
    cobrand: this.props.match
      ? this.getCobrandById(this.props.match.params.cobrandId)
      : JSON.parse(localStorage.getItem("userData")).cobrands[0],
    showBanner: false,
    rowsPerPage: 50
  };

  componentDidMount() {
    trackPromise(
      axios
        .get("/api/user/getUsersList", {
          headers: {
            Authorization: JSON.parse(localStorage.getItem("userData")).token,
            "Cobrand-Id": this.state.cobrand.id
          }
        })
        .then(res => {
          this.setState({ users: res.data });
        })
        .catch(err => {
          console.log(err);
        })
    );
  }

  callbackfunction = didCreateUser => {
    this.setState({ showBanner: didCreateUser });
  };
  handleChange = e => {
    this.setState({ searchTerm: e.target.value });
  };

  handleCreateUser = async event => {
    event.preventDefault();
    this.props.history.push({
      pathname: "/userMgmt/edit_1/" + this.state.cobrand.id
    });
  };
  checkuser = user => {
    if (
      (user.username &&
        user.username
          .toLowerCase()
          .indexOf(this.state.searchTerm.toLowerCase()) !== -1) ||
      (user.fname &&
        user.fname.toString().indexOf(this.state.searchTerm) !== -1) ||
      (user.lname &&
        user.lname.toString().indexOf(this.state.searchTerm) !== -1) ||
      (user.role && user.role.toString().indexOf(this.state.searchTerm) !== -1)
    ) {
      return user;
    }
  };
  render() {
    const filteredUsers = [...this.state.users.filter(this.checkuser)];
    /*const filteredUsers = [...this.state.users.filter(user => 
            user.username.toLowerCase().indexOf(this.state.searchTerm.toLowerCase()) !== -1 || user.fname.toString().indexOf(this.state.searchTerm) !== -1
            || user.lname.toString().indexOf(this.state.searchTerm) !== -1 || user.role.toString().indexOf(this.state.searchTerm) !== -1)
        ]; */

    return (
      <React.Fragment>
        <div className="container main">
          <div className="row mt-4 mb-2">
            <div className="col-md-4 ml-auto">
              <CobrandSelector />
            </div>
          </div>
          <div class="heading mt-2">Manage Users</div>
          <div className="mb-4 text-right">
            {/*<button
                            type="button"
                            className="btn btn-primary"
                            onClick={this.handleCreateUser}
                            >
                            Create User
                            </button>*/}

            <Link
              className="font-weight-bold text-center mt-2"
              to={{ pathname: "/userMgmt/edit_1/" + this.state.cobrand.id }}
            >
              CREATE USER
            </Link>
          </div>
          <div className="row mt-2 mb-4 d-flex justify-content-end">
            <div className="col col-md-4">
              <Search
                searchTerm={this.handleChange}
                placeholder={"Search by Login Name, Name, Role"}
              />
            </div>
          </div>

          <UsersTable
            data={filteredUsers}
            paginationPerPage={this.state.rowsPerPage}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default Users;
